import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

export const ThreadListHeader = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 ${px2rem(16)};
  height: ${px2rem(50)};
  font-size: ${px2rem(12)};
  color: ${props => props.theme.grey800};
  background-color: ${props => props.theme.white100};
`;
ThreadListHeader.displayName = "ThreadListHeader";

export const ThreadListWrapper = styled.div`
  background-color: #fff;
`;
ThreadListWrapper.displayName = "ThreadListWrapper";
